export enum HonorificCodeEnum {
  /** 様 */ SAMA = '1',
  /** 御中 */ ONCHU = '2',
}

export const HonorificCode = [
  { label: '様 ', value: HonorificCodeEnum.SAMA },
  { label: '御中', value: HonorificCodeEnum.ONCHU },
];
